
import React, {createRef} from 'react'
import {connect} from "react-redux";
import {servidor, servicioRestfulCompleto} from "../Configuracion";
import PropTypes from "prop-types";
import Titulo from "../../framework2/ej2/UI/Titulo";
import SignaturePad from 'signature_pad';
import {getValorCampo, onKeyDown, showCampo, showComponente} from "../utils/FormularioUtils";

class ConsentimientoFirma extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            cargandoDatos: false,
        }
        this.canvasRef = createRef();
        this.sigPad = null;
    }

    componentDidMount() {
        const canvas = this.canvasRef.current;
        this.sigPad = new SignaturePad(canvas, {
            penColor: 'black',
            backgroundColor: 'white',
        });
    }

    //------------------------------------------------------------------------------------------------------------------
    // FIRMA
    //------------------------------------------------------------------------------------------------------------------

    limpiar = () => {
        this.sigPad.clear();
    };


    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES
    //------------------------------------------------------------------------------------------------------------------

    onCancelar= () => {
        const {onCancelar} = this.props;
        onCancelar && onCancelar();
    }

    onAceptar= () => {
        const {onAceptar} = this.props;;
        let data64 = "";
        if (!this.sigPad.isEmpty())
            data64= this.sigPad.toDataURL("image/png");
        onAceptar && onAceptar(data64);
    }


    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------


    render() {
        const {fecha, esMenorDeEdad, tutorNombre, tutorDni} = this.state;
        const {paciente} = this.props;

        return (
            <div style={{margin: 8, padding: 4}}>
                 <div className="fr_seccion">
                    <h2>Firma aquí</h2>
                    <canvas
                        ref={this.canvasRef}
                        width={500}
                        height={200}
                        style={{ border: '1px solid #ccc' }}
                    />
                </div>

                <div style={{ marginTop: 10 }}>
                    <button onClick={this.limpiar}>Borrar</button>
                    <button onClick={this.onCancelar} style={{ marginLeft: 10 }}>Cancelar</button>
                    <button onClick={this.onAceptar} style={{ marginLeft: 10 }}>Aceptar</button>
                </div>

            </div>
        )
    }

}

ConsentimientoFirma.propTypes = {
    paciente: PropTypes.object,
    onAceptar: PropTypes.func,
    onCancelar: PropTypes.func,

}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
    }
}
export default connect(mapStateToProps)(ConsentimientoFirma);



